const ChildPickupBehaviorIds = {
    ShowOtherParentsPickupOption: 'ShowOtherParentsPickupOption',
    RequiresPickupInfo: 'RequiresPickupInfo',
    CanCreateRelation: 'CanCreateRelation',
};

export default ChildPickupBehaviorIds;
